import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $0e72ce07e194e26a$exports = {};
$0e72ce07e194e26a$exports = import.meta.resolve("iNXl2");


// start-snippet{displaymode.fixed}
const $e220a08451d0a9eb$var$game = new $6TXE3.Engine({
    width: 600,
    height: 400,
    displayMode: $6TXE3.DisplayMode.Fixed // highlight-line
});
// end-snippet{displaymode.fixed}
const $e220a08451d0a9eb$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($0e72ce07e194e26a$exports))));
const $e220a08451d0a9eb$var$loader = new $6TXE3.Loader([
    $e220a08451d0a9eb$var$playerImage
]);
$e220a08451d0a9eb$var$game.start($e220a08451d0a9eb$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $e220a08451d0a9eb$var$game.screen.center
    });
    actor.graphics.use($e220a08451d0a9eb$var$playerImage.toSprite());
    $e220a08451d0a9eb$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fixed.b5f40e5a.js.map
